const toAmount = (value) => {
  const parsed = Number(String(value ?? "").replace(/,/g, "").trim());
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getMinimumRewardingOrderEligibility = ({
  checkoutValue,
  minimumRewardingOrderValue,
}) => {
  const minimumValue = toAmount(minimumRewardingOrderValue);
  const hasMinimumValue = minimumValue > 0;

  return {
    minimumValue,
    hasMinimumValue,
    isEligible: !hasMinimumValue || toAmount(checkoutValue) >= minimumValue,
  };
};
